import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EluxButton, EluxModal } from '@elxjs/ui'

@Component({
  selector: 'app-confirm-delete-modal',
  standalone: true,
  imports: [EluxModal, EluxButton],
  templateUrl: './confirm-delete-modal.component.html',
  styleUrls: ['./confirm-delete-modal.component.scss'],
})
export class ConfirmDeleteModalComponent {
  @Input() title: string = ''
  @Input() body: string = ''

  @Output() confirm = new EventEmitter<void>()
  @Output() cancel = new EventEmitter<void>()
}
